import store from '@store'

export function handleActions(actions, params) {
  let promises = []
  if (actions) {
    store.dispatch('handleGlobalLoader', true, { root: true })
    actions.map(action => {
      let promise = store.dispatch(action, params)
      promises.push(promise)
    })
  }
  return Promise.all(promises)
}

export function beforeRouteEnterAction(to, from, next) {
  let params = to.params
  return handleActions(to.meta.actions, params)
    .then(() => next())
    .catch(() => next())
}
